export const selectors = {
	field: 'div.form-field',
	fieldError: '.field-error',
};

export const classes = {
	valid: 'form-field--valid',
	error: 'form-field--error',
	required: 'form-field--required',
};

export const dataAttributes = {
	fieldType: 'data-field-type',
	fieldName: 'data-field-name',
	fieldError: 'data-field-error',
	fieldPattern: 'data-pattern',
};
